export default __webpack_public_path__ + "assets/7b761d239b1e3013cb1feb67dba76b4c.jpeg";